import React from "react";
import classNames from "classnames";
import { CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES } from "@highnote/server/src/sdk";
import { Persona } from "./personas";
import "./PromptCard.scss";

import daubreyImg from "App/common/images/personaImages/daubrey.jpg";
import nupaulImg from "App/common/images/personaImages/nupaul.jpg";
import klezraImg from "App/common/images/personaImages/klezra.jpg";
import zaneLofiImg from "App/common/images/personaImages/zaneLofi.jpg";
import booskiImg from "App/common/images/personaImages/booski.jpg";
import noprahImg from "App/common/images/personaImages/noprah.jpg";
import lendrickImg from "App/common/images/personaImages/lendrick.jpg";

const PERSONA_IMAGES: Record<string, string> = {
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.DAUBREY]: daubreyImg,
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.NUPAUL]: nupaulImg,
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.KLEZRA]: klezraImg,
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.LAYNE_ZO]: zaneLofiImg,
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.GIFS]: booskiImg,
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.NOPRAH]: noprahImg,
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.LENDRICK]: lendrickImg,
};

interface PromptCardProps {
  option: Persona;
  selected: boolean;
  onClick: () => void;
}

export const PromptCard: React.FC<PromptCardProps> = ({
  option,
  selected,
  onClick,
}) => {
  const personaImage = PERSONA_IMAGES[option.id];

  return (
    <button
      className={classNames("prompt-card", {
        "prompt-card--selected": selected,
      })}
      onClick={onClick}
      type="button"
    >
      <div className="prompt-card__content">
        {personaImage ? (
          <img
            src={personaImage}
            alt={option.name}
            className="prompt-card__avatar"
          />
        ) : (
          <span className="prompt-card__emoji">{option.emoji}</span>
        )}
        <div className="prompt-card__text">
          <div className="prompt-card__header">{option.name}</div>
          <div className="prompt-card__sub">{option.sub}</div>
        </div>
      </div>
    </button>
  );
};
